import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { Combobox, InputTextCustom, Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useDispatch } from 'react-redux';
import { getPaymentMethodsForCombo } from "../../../../../services/SupplierController";
import { ComboDataDTO, defaultComboDataDTO } from "../../../../../dto/ComboDataDTO";
import { PaymentAccount } from "../../../../../dto/profiledata/ProfileDataFormDTO";

interface PaymentAccountModalModalProps {
  openPaymentAccountModalModal: boolean;
  setOpenPaymentAccountModalModal: (open: boolean) => void;
  isEdditing: boolean;
  paymentAccount: PaymentAccount;
  onClose:()=>void;
  onSave:(account:PaymentAccount)=>void;
}

export default function PaymentAccountModalModal({openPaymentAccountModalModal, setOpenPaymentAccountModalModal, paymentAccount, isEdditing, onClose, onSave}: PaymentAccountModalModalProps) {

    const dispatch = useDispatch();
    const intl = useIntl();
    const [isMobile] = useState(window.innerWidth <= 768);

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<ComboDataDTO>(paymentAccount.paymentMethod || defaultComboDataDTO);
    const [accountId, setAccountId] = useState<string>(paymentAccount.accountId || '');
    const [accountDesc, setAccountDesc] = useState<string>(paymentAccount.description || '');

    useEffect(() => {
        setSelectedPaymentMethod(paymentAccount.paymentMethod || defaultComboDataDTO);
        setAccountId(paymentAccount.accountId || '');
        setAccountDesc(paymentAccount.description || '');
    }, [openPaymentAccountModalModal]);
    
    return (<Modal
        visible={openPaymentAccountModalModal}
        setVisible={setOpenPaymentAccountModalModal}
        header={isEdditing ? (<span style={{fontSize: '20px'}}><strong style={{fontSize: 'inherit'}}>Editar</strong> cuenta de pago</span>) : (<span style={{fontSize: '20px'}}><strong style={{fontSize:'inherit'}}>Nueva</strong> cuenta de pago</span>)}
        width='w-medium'
        >
        <div>
            <div>
                <Combobox  
                    placeholder='Método' 
                    autocompleteClassName="combobox-border"   
                    getItems={getPaymentMethodsForCombo}
                    optionLabel='name'
                    value={selectedPaymentMethod.name}
                    setValue={(paymentAccountMethod: ComboDataDTO) => {
                        if(paymentAccountMethod == null) return;
                        setSelectedPaymentMethod(paymentAccountMethod);
                    }}
                />
                <InputTextCustom
                    className="white-component"
                    spanClassName="border2"
                    name="identifier"
                    value={accountId}
                    onChange={(e) => {
                        if(e == null) return;
                        setAccountId(e.target.value);
                    }}
                    label="Identificador"
                />
                <InputTextCustom
                    className="white-component"
                    spanClassName="border2"
                    name="description"
                    value={accountDesc}
                    onChange={(e) => {
                        if(e == null) return;
                        setAccountDesc(e.target.value )
                    }}
                    label="Descripción"
                />
            </div>
            <div className="profile-data-form-view">
                <div className='modal-buttons'>
                    <button 
                        className="primaryBtn" 
                        disabled={!accountDesc || !accountId || !selectedPaymentMethod} 
                        onClick={() => onSave({
                            paymentaccount: paymentAccount.paymentaccount,
                            paymentMethod: selectedPaymentMethod,
                            accountId: accountId,
                            description: accountDesc,
                            delete: false,
                            insert: !isEdditing
                        })}
                    >
                        {isEdditing ? 'Guardar' : 'Agregar'}
                    </button>
                    <button className="secondaryBtn" onClick={() => onClose()}>Cancelar</button>
                </div>
            </div>
        </div>
        </Modal>
    )
}